import { ReactComponent as AlertTagLong } from 'assets/icons/icon-alert-tag-long.svg';

export default AlertTagLong;
